import Q11 from './Q11';

export default Q11;
